import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  details: {
    display: 'grid',
    textAlign: 'left',
    gridTemplateColumns: '2fr 4fr 2fr 2fr 2fr',
    wordBreak: 'break-all'
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(3),
    '&:last-child': {
      marginRight: 'initial'
    }
  }
}));